<!-- eslint-disable prettier/prettier -->
<mat-card appearance="outlined">
	<mat-card-content>
		@if (soloLectura) {

		<!-- ─── Vista resumen ──────────────────────────────────────────────── -->
		<div class="info-read">
			<div class="pi-section-header">
				<p class="pi-section-title">Información personal</p>
				<button mat-button class="pi-edit-btn" (click)="editarClick.emit()">
					<lucide-icon name="pencil" [size]="16" [strokeWidth]="1.5" color="#5f1f7b"></lucide-icon>
					Editar
				</button>
			</div>

			<div class="info-read__grid">
				<div class="info-field">
					<span class="info-field__label">CUIL</span>
					<span class="info-field__value">{{ userData()?.cuil || userData()?.username || '—' }}</span>
				</div>
				<div class="info-field">
					<span class="info-field__label">Fecha de nacimiento</span>
					<span class="info-field__value">{{ formatDate(userData()?.fechaDeNacimiento) || '—' }}</span>
				</div>
				<div class="info-field">
					<span class="info-field__label">Nombre</span>
					<span class="info-field__value">{{ userData()?.nombre || '—' }}</span>
				</div>
				<div class="info-field">
					<span class="info-field__label">Sexo</span>
					<span class="info-field__value">{{ userData()?.sexo || '—' }}</span>
				</div>
				<div class="info-field">
					<span class="info-field__label">Apellido</span>
					<span class="info-field__value">{{ userData()?.apellido || '—' }}</span>
				</div>
				<div class="info-field">
					<span class="info-field__label">Nacionalidad</span>
					<span class="info-field__value">{{ userData()?.nacionalidad || '—' }}</span>
				</div>
			</div>
		</div>

		} @else {

		<!-- ─── Vista edición ──────────────────────────────────────────────── -->
		<div class="pi-section-header">
			<p class="pi-section-title">Información personal</p>
			<div class="pi-section-header__actions">
				<button mat-flat-button class="btn-primary" (click)="guardarClick.emit()">Guardar</button>
				<button mat-button class="pi-cancel-btn" (click)="cancelarClick.emit()">Cancelar</button>
			</div>
		</div>
		<div class="pt-4 text-left">
			<form [formGroup]="personalInfoForm" class="flex flex-col gap-6">
				<div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
					<!-- CUIL -->
					<div>
						<mat-form-field appearance="outline" class="w-full">
							<mat-label>CUIL</mat-label>
							<input matInput placeholder="20164974058" formControlName="cuil" />
						</mat-form-field>
						<mat-error>
							@if (personalInfoForm.get('cuil')?.touched) { {{
							personalInfoForm.get('cuil')!.errors | formErrors }} }
						</mat-error>
					</div>

					<!-- Nombre -->
					<div>
						<mat-form-field appearance="outline" class="w-full">
							<mat-label>Nombre</mat-label>
							<input matInput placeholder="Leo" formControlName="nombre" />
						</mat-form-field>
						<mat-error>
							@if (personalInfoForm.get('nombre')?.touched) { {{
							personalInfoForm.get('nombre')!.errors | formErrors }} }
						</mat-error>
					</div>

					<!-- Apellido -->
					<div>
						<mat-form-field appearance="outline" class="w-full">
							<mat-label>Apellido</mat-label>
							<input matInput placeholder="Blum" formControlName="apellido" />
						</mat-form-field>
					</div>
				</div>

				<div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
					<!-- Fecha de nacimiento -->
					<div>
						<mat-form-field appearance="outline" class="w-full">
							<mat-label>Fecha de nacimiento</mat-label>
							<input
								matInput
								[matDatepicker]="picker"
								placeholder="DD/MM/YYYY"
								formControlName="fechaDeNacimiento"
								[max]="maxDate"
							/>
							<mat-datepicker-toggle matIconSuffix [for]="picker" />
							<mat-datepicker #picker />
						</mat-form-field>
						<mat-error>
							@if (personalInfoForm.get('fechaDeNacimiento')?.touched) { {{
							personalInfoForm.get('fechaDeNacimiento')!.errors | formErrors }} }
						</mat-error>
					</div>

					<!-- Sexo -->
					<div>
						<mat-form-field appearance="outline" class="w-full">
							<mat-label>Sexo</mat-label>
							<mat-select formControlName="sexo">
								@for (s of tiposSexo; track s.id) {
								<mat-option [value]="s.id">{{ s.description }}</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-error>
							@if (personalInfoForm.get('sexo')?.touched) { {{
							personalInfoForm.get('sexo')!.errors | formErrors }} }
						</mat-error>
					</div>

					<!-- Nacionalidad -->
					<div>
						<mat-form-field appearance="outline" class="w-full">
							<mat-label>Nacionalidad</mat-label>
							<mat-select formControlName="nacionalidad">
								@for (n of nacionalidades; track n.id) {
								<mat-option [value]="n.id">{{ n.description }}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</form>
		</div>

		}
	</mat-card-content>
</mat-card>
